import AdminSettingsMain from '@Containers/Settings/AdminSettings/AdminSettingsMain/AdminSettingsMain.container';

const AdminSettingsPage: React.FunctionComponent = (): JSX.Element => (
  <AdminSettingsMain />
);

export default AdminSettingsPage;
